import React, { useEffect, useState } from "react";

import PageContainer from "../components/shared/PageContainer";
import TemplateSetsTable from "../components/template-set/TemplateSetsTable";
import * as Objects from "../services/api";

export const TemplateSets: React.FC = () => {
  const [templateSets, setTemplateSets] = useState<Objects.TemplateSetAggregate[]>([]);
  useEffect(() => {
    Objects.TemplateSets.list().then(setTemplateSets);
  }, []);

  return (
    <PageContainer>
      <TemplateSetsTable templateSets={templateSets} />
    </PageContainer>
  );
};

export default TemplateSets;
